import { Navigate } from "react-router-dom";
import { LoadingIndicator } from "@/components/application/loading-indicator/loading-indicator";
import { useAcomAdmin } from "@/hooks/use-acom-admin";
import { useClientAdmin } from "@/hooks/use-client-admin";

interface RequireNonAdminProps {
    children: React.ReactNode;
}

/**
 * Route guard that only renders children if the current user is NOT an admin.
 * Redirects ACOM admins to /admin and ClientAdmins to /client-admin.
 * Shows loading indicator while checking.
 */
export function RequireNonAdmin({ children }: RequireNonAdminProps) {
    const { isAcomAdmin, isLoaded: acomLoaded } = useAcomAdmin();
    const { isClientAdmin, isLoaded: clientAdminLoaded } = useClientAdmin();

    if (!acomLoaded || !clientAdminLoaded) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <LoadingIndicator size="lg" label="Loading..." />
            </div>
        );
    }

    if (isAcomAdmin) {
        return <Navigate to="/admin" replace />;
    }

    if (isClientAdmin) {
        return <Navigate to="/client-admin" replace />;
    }

    return <>{children}</>;
}
